import React from 'react'

import * as styles from './styles.module.scss'

interface AnimatedTextProps {
	text: string
	delay?: number
	speed?: number
}

const AnimatedText: React.FC<AnimatedTextProps> = ({
	text,
	delay = 0.5,
	speed = 2
}) => {
	return (
		<>
			{text.split('').map((char, index) => {
				const style = { animationDelay: delay + index / speed + 's' }
				return (
					<span
						aria-hidden="true"
						key={index}
						style={style}
						className={styles.char}
					>
						{char}
					</span>
				)
			})}
		</>
	)
}

export default AnimatedText
